import React, {Component} from "react"
import { Modal, ModalHeader, ModalBody } from 'reactstrap'

import playicon from '../images/i-play-icon.svg'
import closeicon from '../images/i-close-modal.svg'

export default class BannerSalonVideo extends Component{

	constructor(props) {
		super(props);
		this.state = {
			modal: false,
		};

		this.toggle = this.toggle.bind(this);
	  }

	toggle() {
		this.setState(prevState => ({
			modal: !prevState.modal
		}));
	}

	render(){

		const closeBtn = <img className="close" alt="cerrar" onClick={this.toggle} src={closeicon}/>;

		return(
			<div>
				<button className="btn btn-video" onClick={this.toggle}>
					<img src={playicon} alt="Play" width="45" height="45"/>
					<span>{this.props.buttonLabel}</span>
				</button>
				<Modal size="xl" centered isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
					<ModalHeader toggle={this.toggle} close={closeBtn}></ModalHeader>
					<ModalBody>
						{this.props.videosrc}
					</ModalBody>
				</Modal>
			</div>
		)
	}
}
